import { NotificationToast } from './NotificationToast';
import type { Notification } from '../../types/notification.types';

interface NotificationToastContainerProps {
  toasts: Array<{ id: string; notification: Notification }>;
  onRemove: (id: string) => void;
  onOpen: (id: string, notification: Notification) => void;
}

export const NotificationToastContainer = ({
  toasts,
  onRemove,
  onOpen,
}: NotificationToastContainerProps) => {
  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 pointer-events-none">
      <div className="flex flex-col-reverse pointer-events-auto">
        {toasts.map(({ id, notification }) => (
          <NotificationToast
            key={id}
            notification={notification}
            onClose={() => onRemove(id)}
            onOpen={() => onOpen(id, notification)}
          />
        ))}
      </div>
    </div>
  );
};
